/* eslint-disable react/no-danger */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useAuth } from '../../contexts/auth';
import { CreateTicket, handleImpressionsTrack } from '../../api';
import Checkbox from './Checkbox';
import FaqTicketCreate from '../common/FaqTicketCreate';
import FaqFeedback from '../common/FaqFeedback';
import TextAndButton from './TextAndButton';
import styles from '../../styles/Accordion.module.scss';
import {
  clickTracker,
  getProjectId,
  getSourceValue,
  handleRedirection,
  hasJdMartVertical,
  helpfulObjData,
} from '../../lib/common';
import { handleShowTagsFeedback } from '../../reducersAndActions/actions/appStateActions';
import { useAppState } from '../../contexts/appState';

const ContractFaq = ({ contractData }) => {
  let searchQid = '';
  searchQid = localStorage.getItem('searchQid');

  const { faqDetails, contractDetails } = contractData;
  const [faqData] = useState(faqDetails || []);
  const [faqResponse, setFaqResponse] = useState(faqDetails || []);
  const [selectedQuestionId, setSelectedQuestionId] = useState(null);
  const [setActive, setActiveState] = useState('');
  const [showAns, setShowAns] = useState(false);
  const [helpful, setHelpful] = useState(helpfulObjData && helpfulObjData);
  const [activeIndex, setActiveIndex] = useState(-1);
  const [showData, setShowData] = useState(true);
  const [faqsFeedbackData, setFaqsFeedbackData] = useState({});
  const [selectedFaqData, setSelectedFaqData] = useState({});
  const [showTicketCreate, setShowTicketCreate] = useState(false);
  const [showResp, setShowResp] = useState('');
  const [showSpecialNumberCheckbox, setShowSpecialNumberCheckbox] = useState(false);
  const [selectedCheckboxItem, setSelectedCheckboxItem] = useState(null);
  const projectId = getProjectId();
  const source = getSourceValue();
  const [authState] = useAuth();
  const { selectedBusiness, userDetails } = authState;
  const selectedBusinessGenio = JSON.parse(localStorage.getItem('selectedBusinessGenio'));
  const queryParams = new URLSearchParams(window.location.search);
  const profile = JSON.parse(sessionStorage.getItem('profileDetails'));
  const [selectedDefaultNumArr, setSelectedDefaultNumArr] = useState([]);
  const [, appDispatch] = useAppState();

  const checkboxesTypes = {
    renewalcalls: [
      'Already renewed',
      "Unsatisfied with Justdial's services",
      'Getting repeated calls',
      'Contract is currently active',
      'Others',
    ],
    tempstop: [
      'Getting no leads or irrelevant leads',
      'Getting less leads than promised',
      "Unsatisfied with Justdial's services",
      'Business shut down',
      'Others',
    ],
    specialnumberblock: [
      'Not receiving any calls',
      'Getting irrelevant calls',
      "Don't know what special number is",
      'Others',
    ],
  };
  const [checkedItems, setCheckedItems] = useState(checkboxesTypes?.[selectedFaqData?.faqKey]);

  let manageContractFaqs = faqData?.filter((each) => [1, 2, 3, 4, 5, 6, 7].includes(each.pop));
  const specialNumFaqs = faqData?.filter((each) => [8, 9, 10, 11].includes(each.pop));

  if (contractDetails?.hidePositionClarificationFaq) {
    manageContractFaqs = manageContractFaqs.filter((each) => each?.pop !== 1);
  }

  if (contractDetails?.hasLawyerCategoryFlag) {
    manageContractFaqs = manageContractFaqs.filter((each) => each?.pop !== 2);
  }

  const updatedFaqs = [
    {
      title: 'Manage Contract',
      faqs: manageContractFaqs,
    },
    {
      title: 'Special Number',
      faqs: specialNumFaqs,
    },
  ];
  const handlePaymentClick = async (e) => {
    if (document.getElementById('paymentInvoice')) {
      if (e.target.id === 'paymentInvoice' && selectedFaqData?.paramUrl) {
        await clickTracker('FAQ_clarification_redirection', 'contract_FAQ_clarification');
        if (projectId === 'csportal') {
          const liVal = 'click';
          const liTrd = `cta_clickhere`;
          const faqTypeVal = '';
          const othersData = [];
          const llTrd = `issue_contract`;
          const llTrdInside = `faq_${selectedFaqData?.faqKey}`;
          await handleImpressionsTrack(liVal, liTrd, faqTypeVal, othersData, llTrd, authState, llTrdInside);
        }
        handleRedirection(source, selectedFaqData?.paramUrl || '');
      }
    } else if (document.getElementById('pmt') && e.target.id === 'pmt') {
      console.log();
    }
  };

  useEffect(() => {
    setCheckedItems(checkboxesTypes?.[selectedFaqData?.faqKey]);
    window.addEventListener('click', handlePaymentClick);
    return () => {
      window.removeEventListener('click', handlePaymentClick);
    };
  }, [selectedFaqData, showResp]);

  const handleFaqClick = async (data) => {
    handleShowTagsFeedback(appDispatch, {});
    setShowData(true);
    setActiveIndex(data?.pop === activeIndex ? -1 : data?.pop);
    setHelpful(helpfulObjData && helpfulObjData);
    setSelectedFaqData(data);
    setSelectedQuestionId(selectedQuestionId === data?.pop ? null : data?.pop);
    setShowAns(selectedQuestionId !== data?.pop);
    setActiveState(setActive === '' || selectedQuestionId !== data?.pop ? `${styles.Active}` : ``);
    setShowTicketCreate(false);
    setShowResp('');
    setShowSpecialNumberCheckbox(false);
    setSelectedCheckboxItem(null);
    setSelectedDefaultNumArr([]);
    if (selectedQuestionId !== data?.pop) {
      const fqType = projectId === 'csportal' ? 'contract_Faq' : projectId === 'genio' ? 'genio_contract_Faq' : null;
      await clickTracker(`FAQ_${data?.faqKey}`, fqType);
      if (projectId === 'csportal') {
        const liVal = 'click';
        const liTrd = `click_${data?.faqKey}`;
        const faqTypeVal = '';
        const othersData = [];
        const llTrd = 'click_contract';
        await handleImpressionsTrack(liVal, liTrd, faqTypeVal, othersData, llTrd, authState);
      }
    }
  };

  const handleContractCheckboxSubmit = async (responseVal) => {
    if (['renewalcalls', 'tempstop', 'specialnumberblock'].includes(selectedFaqData?.faqKey)) {
      const otherType =
        projectId === 'csportal'
          ? `contract_FAQ_${selectedFaqData?.faqKey}`
          : projectId === 'genio'
            ? `genio_contract_FAQ_${selectedFaqData?.faqKey}`
            : null;
      await clickTracker(`FAQ_${selectedFaqData?.faqKey}_Others`, otherType);
    }
    if (selectedFaqData?.faqKey === 'changemanager' || showTicketCreate) {
      const cmsubmitType =
        projectId === 'csportal'
          ? `contract_FAQ_${selectedFaqData?.faqKey}`
          : projectId === 'genio'
            ? `genio_contract_FAQ_${selectedFaqData?.faqKey}`
            : null;
      await clickTracker(`FAQ_${selectedFaqData?.faqKey}_submit`, cmsubmitType);
    } else {
      const ticketType =
        projectId === 'csportal'
          ? 'contract_FAQ_feedback_ticket'
          : projectId === 'genio'
            ? 'genio_contract_FAQ_feedback_ticket'
            : null;
      await clickTracker(`FAQ_${selectedFaqData?.faqKey}_ticket`, ticketType);
    }
    setShowResp(responseVal);
    setCheckedItems(checkboxesTypes?.selectedFaqData?.faqKey);
    if (projectId === 'csportal') {
      const liVal = 'click';
      const liTrd = `click_${selectedFaqData?.faqKey}_submit`;
      const faqTypeVal = '';
      const othersData = [];
      const llTrd = `click_${selectedFaqData?.faqKey}`;
      const llTrdInside = `faq_${selectedFaqData?.faqKey}`;
      await handleImpressionsTrack(liVal, liTrd, faqTypeVal, othersData, llTrd, authState, llTrdInside);
    }
  };

  const handleCreateTicket = async (e) => {
    e.preventDefault();
    const params = {
      vertical: hasJdMartVertical() ? 'JD MART CORPORATE' : 'Listing',
      category: 'CS',
      ticket_creator: 'BUSINESS',
      nm:
        projectId === 'csportal'
          ? selectedBusiness?.compname || ''
          : selectedBusinessGenio?.contractPersonName || selectedBusinessGenio?.companyName || '',
      created_by: projectId === 'csportal' ? userDetails?.mobile || '' : profile?.mobile || '',
      mob: projectId === 'csportal' ? userDetails?.mobile || '' : selectedBusinessGenio?.mobile || '',
      issue_type: selectedFaqData?.issue || '',
      issue_sub_type: selectedFaqData?.subIssue || '',
      issue_comment: selectedCheckboxItem || '',
      document: [],
      city:
        projectId === 'genio'
          ? selectedBusinessGenio?.city || ''
          : queryParams.get('city') || selectedBusiness?.data_city,
      oid: '',
      orderid: '',
      docid:
        projectId === 'genio'
          ? selectedBusinessGenio?.docId || ''
          : queryParams.get('pid') || selectedBusiness?.docid || '',
      src: projectId === 'genio' ? 'sales-genio' : 'business',
      src_typ:
        projectId === 'genio' ? (selectedBusinessGenio?.concern === 'client' ? 'client' : 'internal') : 'csportal',
      src_nm: projectId === 'csportal' ? userDetails?.fullName || '' : profile?.full_name || '',
      src_mob: projectId === 'csportal' ? userDetails?.mobile || '' : profile?.mobile || '',
      projectId: projectId === 'csportal' ? 1 : '',
      parentId: projectId === 'genio' ? selectedBusinessGenio?.parentId || '' : selectedBusiness?.parentid || '',
      compnm: projectId === 'genio' ? selectedBusinessGenio?.companyName || '' : selectedBusiness?.compname || '',
      bypass_autoclassify: selectedCheckboxItem ? 1 : 0,
    };

    const res = await CreateTicket(params);
    if (res?.errorCode === 0) {
      setShowResp(res?.result?.msg || '');
    }
    await clickTracker(
      `FAQ_${selectedFaqData?.faqKey}_${selectedCheckboxItem}`,
      `contract_FAQ_${selectedFaqData?.faqKey}`,
    );
    await clickTracker(`FAQ_${selectedFaqData?.faqKey}_submit`, `contract_FAQ_${selectedFaqData?.faqKey}`);
    if (projectId === 'csportal') {
      const liVal = 'click';
      const liTrd = `cta_submit`;
      const faqTypeVal = '';
      const othersData = [];
      const llTrd = `issue_contract`;
      const llTrdInside = `faq_${selectedFaqData?.faqKey}`;
      await handleImpressionsTrack(liVal, liTrd, faqTypeVal, othersData, llTrd, authState, llTrdInside);
    }
  };

  const handleSearchFaq = () => {
    if (searchQid && searchQid !== '') {
      const data = faqData;
      data?.forEach((ele, i) => {
        if (ele?.id?.toString() === searchQid) {
          data?.splice(i, 1);
          data?.unshift(ele);
        }
      });

      data?.forEach((faq) => {
        if (faq?.id?.toString() === searchQid) {
          handleFaqClick(faq);
        }
      });
      setFaqResponse(data);
    }
  };

  useEffect(() => {
    handleSearchFaq();
  }, []);

  const getComponentData = (faqObj, specialNumberFlag) => {
    let component = null;
    const switchType =
      faqObj?.faqKey === 'specialnumberblock' && showSpecialNumberCheckbox ? specialNumberFlag : faqObj?.type;

    switch (switchType) {
      case 'showTextLink':
        component = (
          <div
            aria-label="payment_redirection"
            tabIndex={0}
            role="button"
            onKeyDown={() => {}}
            onClick={handlePaymentClick}
            className="font12 fw400 color777 p-10"
            id="payments-faqs-ans"
            dangerouslySetInnerHTML={{ __html: faqObj?.ans }}
          />
        );
        break;
      case 'textAndButton':
        component = (
          <TextAndButton
            contractDetails={contractDetails}
            setShowSpecialNumberCheckbox={setShowSpecialNumberCheckbox}
            faqObj={faqObj}
            setShowResp={setShowResp}
            selectedDefaultNumArr={selectedDefaultNumArr}
            setSelectedDefaultNumArr={setSelectedDefaultNumArr}
          />
        );
        break;
      case 'checkbox':
        component = (
          <>
            <Checkbox
              faqData={faqObj}
              checkedItems={checkedItems}
              showTicketCreate={showTicketCreate}
              setShowTicketCreate={setShowTicketCreate}
              selectedCheckboxItem={selectedCheckboxItem}
              setSelectedCheckboxItem={setSelectedCheckboxItem}
            />
            {showTicketCreate && (
              <div className="p-10">
                <FaqTicketCreate
                  issue={faqObj?.issue || ''}
                  subIssue={faqObj?.subIssue || ''}
                  activeIndex={activeIndex}
                  vertical="Listing"
                  category="CS"
                  ticketCreator="BUSINESS"
                  setShowData={setShowData}
                  hideAlert
                  hideCrossIcon
                  id="contractCheckboxSubmit"
                  faqId={faqObj?.pop}
                  projectId={projectId}
                  handleContractCheckboxSubmit={handleContractCheckboxSubmit}
                  faqObj={faqObj}
                />
              </div>
            )}

            {selectedCheckboxItem !== 'Others' && (
              <div
                className={`${styles.Accordion__TwoButton__Group} p-10`}
                role="group"
                aria-label="Accordion__TwoButton__Group"
              >
                <button
                  type="button"
                  className={`${styles.Accordion__Contant__Button} bluefill_animate font14 fw600 colorFFF mt-10`}
                  style={{
                    backgroundColor: `${selectedCheckboxItem ? '#0076d7' : '#CCCCCC'}`,
                    border: `1px solid ${!selectedCheckboxItem ? '#E0E0E0' : '#CCCCCC'}`,
                    transitionProperty: 'background-color, background-image, border-color, box-shadow',
                    transition: 'all 0.8s',
                    color: `#FFFFFF`,
                  }}
                  disabled={!selectedCheckboxItem}
                  onClick={async (e) => handleCreateTicket(e)}
                >
                  Submit
                </button>
              </div>
            )}
          </>
        );
        break;
      default:
        component = 'Answer here...';
    }
    return component;
  };

  return (
    <>
      {updatedFaqs.map((faqObj, index) => (
        <div className="p-20 pt-0" key={index}>
          <div className="font16 fw700 color111 mt-10">{faqObj.title}</div>

          <div className={`${styles.Accordion__Box}`}>
            <div className="mt-10">
              <>
                {faqResponse && faqResponse.length > 0 ? (
                  <>
                    {faqObj &&
                      faqObj?.faqs.map((each, idx) => (
                        <div key={idx}>
                          <div
                            aria-label="faq_click"
                            tabIndex={0}
                            role="button"
                            onKeyDown={() => {}}
                            onClick={() => handleFaqClick(each)}
                            className={`${styles.Accordion__Pannel__Heading} ${
                              selectedQuestionId === each?.pop && showAns ? setActive : ''
                            }`}
                          >
                            <div className={`${styles.Accordion__Pannel__Title} font13 fw500 color111`}>
                              {each?.question || ''}
                            </div>
                            <div className={`${styles.Accordion__Pannel__Icon} csicon`} />
                          </div>
                          <div className={`${styles.Accordion__Contant}`}>
                            <div className={`${styles.Accordion__TextContant}`}>
                              {showData && each?.type !== 'create' ? (
                                <>
                                  {each?.pop === selectedFaqData?.pop && (
                                    <>
                                      {!showResp ? (
                                        <>
                                          {each?.faqKey === 'specialnumberblock' && showSpecialNumberCheckbox
                                            ? getComponentData(each, 'checkbox')
                                            : getComponentData(each)}
                                        </>
                                      ) : (
                                        <div className="font12 fw400 color777 p-10" style={{ height: 'fit-content' }}>
                                          {showResp}
                                        </div>
                                      )}
                                    </>
                                  )}
                                  {(!['renewalcalls', 'tempstop', 'specialnumberblock', 'specialnumberadd'].includes(
                                    each?.faqKey,
                                  ) ||
                                    (projectId === 'genio' &&
                                      ['specialnumberblock', 'specialnumberadd'].includes(each?.faqKey))) && (
                                    <FaqFeedback
                                      faq={each}
                                      helpful={helpful}
                                      setHelpful={setHelpful}
                                      setShowData={setShowData}
                                      faqsFeedbackData={faqsFeedbackData}
                                      setFaqsFeedbackData={setFaqsFeedbackData}
                                      id="contract"
                                      projectId={projectId}
                                    />
                                  )}
                                </>
                              ) : (
                                <>
                                  {((helpful && helpful[1].isActive) || each?.type === 'create') && (
                                    <div className={each?.type === 'create' || projectId === 'genio' ? 'p-10' : ''}>
                                      <FaqTicketCreate
                                        issue={each?.issue || ''}
                                        subIssue={each?.subIssue || ''}
                                        activeIndex={activeIndex}
                                        vertical="Listing"
                                        category="CS"
                                        ticketCreator="BUSINESS"
                                        setShowData={setShowData}
                                        hideAlert
                                        hideCrossIcon={each?.type === 'create'}
                                        id="contract"
                                        faqId={each?.pop}
                                        projectId={projectId}
                                        handleContractCheckboxSubmit={handleContractCheckboxSubmit}
                                        faqObj={each}
                                      />
                                    </div>
                                  )}
                                </>
                              )}
                            </div>
                          </div>
                        </div>
                      ))}
                  </>
                ) : (
                  <div className="no-data-div">No Data</div>
                )}
              </>
            </div>
          </div>
        </div>
      ))}
    </>
  );
};

export default ContractFaq;

ContractFaq.propTypes = {
  contractData: PropTypes.object,
};
